var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.addresses.length !== 0)?_c('b-row',{staticClass:"mt-2"},[_c('b-col',[_c('b-card',{staticClass:"rounded-0"},[_c('h4',[_vm._v("\n        "+_vm._s(_vm.$t('message.adminUserAddress.title'))+"\n      ")]),_vm._v(" "),_c('b-table',{attrs:{"striped":"","responsive":"","fields":_vm.fields,"items":_vm.addresses,"tbody-class":"text-muted"}})],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98f4cedc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminUserAddress.vue
// module id = oIsk
// module chunks = 1